export const BOARD_PACK_REPORT = {
  headline: 'Couldn’t read the Finance sheet',
  status: 'failed',
  durationSec: 12,
  body: `**The board pack didn’t finish — Google Sheets access has expired.**

HubSpot metrics came through, but the Finance sheet returned *401 Unauthorized* when I tried to read ARR, burn, and churn.

**To fix it:** reconnect Google Sheets in Connected apps, then ask me to “run the board metrics pack”. I’ll pick up from here.

**What I already have**

- Bookings: $412k (+18% on the previous month)
- Pipeline coverage: 3.1×
- Win rate: 27% (−2 pts)`,
}
